export default __webpack_public_path__ + "static/media/pythonmastery.016bc796.svg";